exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".swal2-actions button[data-v-7715a4d3] {\n  text-transform: uppercase;\n  font-weight: 600 !important;\n}\nbutton.sau-power i[data-v-7715a4d3] {\n  font-size: 2rem;\n}\nselect[data-v-7715a4d3] {\n  -moz-appearance: auto !important;\n  -webkit-appearance: auto !important;\n}\n", ""]);

// exports
